import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"


import { surveyStore } from '@/stores/survey'
import SurveyQuestionCard from '@/views/survey/cards/SurveyQuestionCard.vue'
import SurveyEvidenceCard from '@/views/survey/cards/SurveyEvidenceCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyChapterCard',
  props: {
  chapter: Object,
  chapterIndex: Number
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: __props.chapter.name,
    bordered: false
  }, {
    default: _withCtx(() => [
      (_unref(surveyStore)().survey.survey_form.type === 5)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.chapter.questions, (question, index) => {
            return (_openBlock(), _createBlock(SurveyEvidenceCard, {
              question: question,
              questionIndex: index,
              key: question.id
            }, null, 8, ["question", "questionIndex"]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.chapter.questions, (question, index) => {
            return (_openBlock(), _createBlock(SurveyQuestionCard, {
              question: question,
              chapterIndex: props.chapterIndex,
              questionIndex: index,
              key: question.id
            }, null, 8, ["question", "chapterIndex", "questionIndex"]))
          }), 128))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})